import { defineComponent as _defineComponent } from 'vue'
import HeaderV2 from '@sh/components/Layout/Header/HeaderV2.ts.vue';
import SidebarV2 from '@sh/components/Layout/Sidebar/SidebarV2.ts.vue';
import OptimizerIconV2 from '@sh/components/Utils/OptimizerIconV2.ts.vue';
import userLocalStorage from '@sh/services/userLocalStorage';
import { computed, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardContainer.ts',
  setup(__props) {

const meetupBannerVisibility = ref(true);

const meetupBanner = userLocalStorage.getSettings('meetup-banner');
if (meetupBanner !== undefined) meetupBannerVisibility.value = Boolean(meetupBanner);

const activeMeetupBanner = computed(() => {
  const meetupBanners = {
    leadGen: {
      type: 'leadGen',
      message: '🔥 Join the Most Exclusive Lead Generation Meet-up. - September 5, Budapest 👉',
      buttonText: 'Register Now',
      link: 'https://promo.theoptimizer.io/lead-gen-meetup-budapest?utm_campaign=theoptimizer_in_app_banner',
    },
    searchArb: {
      type: 'searchArb',
      message: '🔥 Join the Biggest Search Arbitrage Meet up of 2024 - September 5, Budapest (limited seats)  👉',
      buttonText: 'Register Now',
      link: 'https://promo.theoptimizer.io/search-arb-meetup-budapest?utm_campaign=optimizer_in_app_banner',
    },
  };

  return Math.random() < 0.5 ? meetupBanners.leadGen : meetupBanners.searchArb;
});

const showMeetupBanner = computed(() => {
  return meetupBannerVisibility.value && new Date() <= new Date('2024-09-04');
});

const onBannerDismissed = () => {
  userLocalStorage.setSettings('meetup-banner', false);
  meetupBannerVisibility.value = false;
};

const onLinkClick = (link: string) => {
  window.open(link, '_blank');
};

return { __sfc: true,meetupBannerVisibility, meetupBanner, activeMeetupBanner, showMeetupBanner, onBannerDismissed, onLinkClick, HeaderV2, SidebarV2, OptimizerIconV2 }
}

})